var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBeachChair = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3n-web/art/beach-chair") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.66870906,2.47043613 L2.39034439,2.47043613 C2.39034439,2.47043613 2.0850412,4.89900046 2.0850412,4.89900046 C0.899746461,4.68789681 0,3.68297364 0,2.47043613 C0,1.10611335 1.13860131,0 2.54299599,0 L2.96323685,0 C3.16078597,0 3.35294739,0.024425216 3.53792521,0.0662970148 C3.53792521,0.0662970148 3.53792521,0.0662970148 3.53792521,0.0662970148 C3.80012677,0.125615396 4.04796112,0.225060919 4.27244876,0.35591029 C4.27244876,0.35591029 4.27244876,0.35591029 4.27604057,0.35591029 L4.27604057,0.35591029 C4.94591168,0.750203062 5.41464188,1.43236445 5.49366153,2.22792863 L5.49366153,2.22792863 C5.50084513,2.30469359 5.50623283,2.38320322 5.50623283,2.46171284 C5.50623283,2.46520216 5.50623283,2.46694681 5.50623283,2.47043613 C5.50623283,2.58558358 5.49545743,2.69898637 5.47929432,2.8106445 C5.47929432,2.8106445 5.47929432,2.8106445 5.47929432,2.8106445 C5.46851891,2.88043083 5.4577435,2.95021716 5.44158039,3.01825883 C5.36974435,3.32531869 5.24043947,3.61318731 5.06084936,3.8644181 L5.06084936,3.8644181 C5.03570674,3.89931127 5.00876822,3.93245977 4.98362561,3.96560828 C4.9638707,3.9900335 4.94591168,4.01794803 4.92436087,4.04237325 L4.92436087,4.04237325 C4.75015846,4.24824292 4.54003803,4.42445341 4.30477498,4.56577073 C4.30477498,4.56577073 4.30477498,4.56577073 4.30477498,4.56577073 C3.91506444,4.80304426 3.45531375,4.94087226 2.96144095,4.94087226 L2.54120008,4.94087226 C2.47834355,4.94087226 2.41728291,4.93563829 2.35622227,4.93214897 L2.66511726,2.47043613 L2.66870906,2.47043613 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3n-web/art/beach-chair",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("g", {
    id: "art/retirement",
    transform: "translate(7, 14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.15,
    cx: 42.5,
    cy: 69.789518,
    rx: 42.5,
    ry: 2.21048205
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.1153, 0)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5B045",
    points: "13.6255018 44.4047399 0 43.4277313 22.2799493 5.38894669"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5B045",
    points: "62.114832 15.1520545 67.254701 2.85570286 22.2799493 5.38894669"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5B045",
    points: "22.2799493 5.38894669 47.5375026 27.4449167 31.4300655 37.1609187"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E9E7DD",
    points: "22.2799493 5.38894669 62.114832 15.1520545 47.5375026 27.4449167"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E9E7DD",
    points: "22.2799493 5.38894669 13.6255018 44.4047399 31.4300655 37.1609187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8946757,0.092164138 C19.1892035,-0.085791007 19.5771181,0.00144190721 19.7603,0.289310524 L63.9268963,69.3865019 L62.4470737,69.3865019 C62.4470737,69.3865019 18.6917389,0.933089431 18.6917389,0.933089431 C18.5085569,0.646965473 18.6001479,0.270119283 18.8946757,0.092164138 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.474963,19.7736542 C18.090112,27.8479328 7.18899218,36.5729689 1.19966195,43.5132195 L0,43.4277313 L4.93693218,37.1539401 L20.6097613,19.407276 L35.9539404,10.1518638 L59.2773083,4.37355557 L67.254701,2.85570286 L66.802134,3.937391 C57.7418128,6.0745974 44.8598141,11.697631 31.474963,19.7719096 L31.474963,19.7736542 Z",
    fill: "#000000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 2.8557)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "0 40.5720284 4.93693218 34.2982372 22.2799493 2.53324383"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "67.254701 0 59.2791042 1.51785271 22.2799493 2.53324383"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "22.2799493 2.53324383 35.9539404 7.29616095 20.6115572 16.5515731"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6C760",
    points: "22.2799493 2.53324383 59.2791042 1.51785271 35.9539404 7.29616095"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6C760",
    points: "22.2799493 2.53324383 4.93693218 34.2982372 20.6115572 16.5515731"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.8306, 37.3882)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.5936, 0.0007)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0, 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#7A4315",
    transform: "translate(10.5193, 19.5918) rotate(-80.42) translate(-10.5193, -19.5918)",
    points: "0.914578042 18.8995937 20.1179391 18.9920774 20.1239937 20.2841043 0.92063262 20.1916207"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#613511",
    points: "12.1648 12.7295345 11.323292 12.150308 11.7356496 9.86655026 12.2058491 9.94157057 12.6163408 10.2242052"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8C4D18",
    transform: "translate(25.3886, 23.4495) rotate(-18.87) translate(-25.3886, -23.4495)",
    points: "1.65820459 22.104229 49.0985891 22.5197325 49.1189762 24.7947564 1.67859163 24.3792529"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 5.04482171,
    cy: 30.1900746,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7A4315",
    points: "27.3930152 23.9808358 25.1050372 22.3443463 27.7935012 21.4510813 30.0814792 23.0893154"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8C4D18",
    transform: "translate(21.3681, 16.2878) rotate(-53.63) translate(-21.3681, -16.2878)",
    points: "19.8725212 -9.14829598 22.1640021 -9.11648805 22.8636786 41.7238196 20.5721977 41.6920116"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 41.0077416,
    cy: 30.320924,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 41.8158971,
    cy: 30.320924,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#703E13",
    transform: "translate(11.3272, 19.5923) rotate(-80.42) translate(-11.3272, -19.5923)",
    points: "1.72253789 18.9000746 20.9258989 18.9925583 20.9319535 20.2845852 1.72859246 20.1921015"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#542E0F",
    points: "12.9740989 12.7295345 12.1332434 12.7295345 12.5443283 9.86655026 13.0152074 9.94157057 13.4262922 10.2242052"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#522D0E",
    points: "4.0624638 31.9975406 49.0875008 17.0458191 48.3332223 14.8998894 3.30638943 29.8498663 3.25430829 31.9975406"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 5.85297722,
    cy: 30.1900746,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#703E13",
    points: "28.2011707 23.9808358 27.3930152 23.9808358 25.9131927 22.3443463 28.6016567 21.4510813 30.8896347 23.0893154"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9C561B",
    points: "0.80829097 2.40988075 42.1607102 31.9975406 43.543554 30.1708834 32.773535 22.4629831 31.9653795 22.4629831 32.3281515 22.1454553 2.19293073 0.58322353 1.38477523 0.58322353"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0, 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#733F14",
    transform: "translate(10.5193, 19.5918) rotate(-80.42) translate(-10.5193, -19.5918)",
    points: "0.914578042 18.8995937 20.1179391 18.9920774 20.1239937 20.2841043 0.92063262 20.1916207"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#613511",
    points: "12.1648 12.7295345 11.323292 12.150308 11.7356496 9.86655026 12.2058491 9.94157057 12.6163408 10.2242052"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#784114",
    transform: "translate(25.3886, 23.4495) rotate(-18.87) translate(-25.3886, -23.4495)",
    points: "1.65820459 22.104229 49.0985891 22.5197325 49.1189762 24.7947564 1.67859163 24.3792529"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 5.04482171,
    cy: 30.1900746,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#733F14",
    points: "27.3930152 23.9808358 25.1050372 22.3443463 27.7935012 21.4510813 30.0814792 23.0893154"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#824716",
    transform: "translate(21.3681, 16.2878) rotate(-53.63) translate(-21.3681, -16.2878)",
    points: "19.8725212 -9.14829598 22.1640021 -9.11648805 22.8636786 41.7238196 20.5721977 41.6920116"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 41.0077416,
    cy: 30.320924,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9C561B",
    points: "48.3332223 14.8998894 47.5250668 14.8998894 48.2793453 17.0458191 49.0875008 17.0458191"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7A4315",
    points: "43.543554 30.1708834 42.7353985 30.1708834 41.3525547 31.9975406 42.1607102 31.9975406"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.1765, 1.6126)",
    fill: "#5E3411",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4000634,14.7999362 C44.4000634,15.3442696 44.8544264,15.7856682 45.4147475,15.7856682 C45.9750687,15.7856682 46.4294317,15.3442696 46.4294317,14.7999362 C46.4294317,14.2556028 45.9750687,13.8142043 45.4147475,13.8142043 C44.8544264,13.8142043 44.4000634,14.2556028 44.4000634,14.7999362 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.985731931 C0,1.53006532 0.454362983,1.97146386 1.01468413,1.97146386 C1.57500528,1.97146386 2.02936827,1.53006532 2.02936827,0.985731931 C2.02936827,0.441398546 1.57500528,0 1.01468413,0 C0.454362983,0 0,0.441398546 0,0.985731931 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.9832, 1.6133)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B7690",
    x: 45.4129516,
    y: 13.815949,
    width: 3.13205155,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 48.5450032,
    y: 13.815949,
    width: 3.13025565,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B7690",
    x: 51.6752588,
    y: 13.815949,
    width: 3.13205155,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 54.8073104,
    y: 13.815949,
    width: 3.13025565,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B7690",
    x: 57.937566,
    y: 13.815949,
    width: 3.13205155,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.186985,14.7999362 C63.186985,15.3442696 63.641348,15.7856682 64.2016691,15.7856682 C64.7619903,15.7856682 65.2163533,15.3442696 65.2163533,14.7999362 C65.2163533,14.2556028 64.7619903,13.8142043 64.2016691,13.8142043 C63.641348,13.8142043 63.186985,14.2556028 63.186985,14.7999362 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1579337,24.0187106 C49.2040989,24.0187106 53.4298542,22.8044284 57.5909571,20.4194806 C61.8921403,17.9542784 64.5734207,15.1593358 64.6847665,15.0424437 L61.552715,15.0424437 C61.5257765,15.0703583 58.5894781,17.3017762 55.2904078,19.3569837 C51.5369744,21.6930811 47.3417494,24.1792192 40.9088316,22.6596218 C31.2486795,20.3776088 20.3008663,0.975263981 20.1913163,0.779862253 L17.0592647,0.779862253 C20.577435,8.0132155 27.7233256,20.9899838 40.6951194,23.5075257 C42.1605747,23.791905 43.6386013,24.0204553 45.1543419,24.0204553 L45.1579337,24.0187106 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 61.0696176,
    y: 13.815949,
    width: 3.13025565,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 16.6695542,
    y: 0.00174465828,
    width: 3.13025565,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B7690",
    x: 13.5375026,
    y: 0.00174465828,
    width: 3.13205155,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 10.407247,
    y: 0.00174465828,
    width: 3.13025565,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B7690",
    x: 7.27519544,
    y: 0.00174465828,
    width: 3.13205155,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 4.14493978,
    y: 0.00174465828,
    width: 3.13025565,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B7690",
    x: 1.01288823,
    y: 0.00174465828,
    width: 3.13205155,
    height: 1.9697192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7869216,0.985731931 C18.7869216,1.53006532 19.2412846,1.97146386 19.8016057,1.97146386 C20.3619269,1.97146386 20.8162899,1.53006532 20.8162899,0.985731931 C20.8162899,0.441398546 20.3619269,0 19.8016057,0 C19.2412846,0 18.7869216,0.441398546 18.7869216,0.985731931 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6548701,0.985731931 C15.6548701,1.53006532 16.109233,1.97146386 16.6695542,1.97146386 C17.2298753,1.97146386 17.6842383,1.53006532 17.6842383,0.985731931 C17.6842383,0.441398546 17.2298753,0 16.6695542,0 C16.109233,0 15.6548701,0.441398546 15.6548701,0.985731931 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0549334,14.7999362 C60.0549334,15.3442696 60.5092964,15.7856682 61.0696176,15.7856682 C61.6299387,15.7856682 62.0843017,15.3442696 62.0843017,14.7999362 C62.0843017,14.2556028 61.6299387,13.8142043 61.0696176,13.8142043 C60.5092964,13.8142043 60.0549334,14.2556028 60.0549334,14.7999362 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0258821,24.0187106 C46.0720473,24.0187106 50.2978027,22.8044284 54.4589056,20.4194806 C58.7600887,17.9542784 61.4413691,15.1593358 61.552715,15.0424437 L58.4224593,15.0424437 C58.3955208,15.0703583 56.412846,16.8778242 52.9593281,19.1231995 C49.2543841,21.5325725 44.2096979,24.1774745 37.778576,22.6578771 C28.1184238,20.3758641 17.1706106,0.973519323 17.0610606,0.778117595 L13.930805,0.778117595 C14.385168,1.59112836 24.9881682,20.9149635 35.0326431,23.2894434 C36.4855271,23.6331411 40.5083457,24.0187106 42.0240862,24.0187106 L42.0258821,24.0187106 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5246144,0.985731931 C12.5246144,1.53006532 12.9789774,1.97146386 13.5392985,1.97146386 C14.0996197,1.97146386 14.5539827,1.53006532 14.5539827,0.985731931 C14.5539827,0.441398546 14.0996197,0 13.5392985,0 C12.9789774,0 12.5246144,0.441398546 12.5246144,0.985731931 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9246778,14.7999362 C56.9246778,15.3442696 57.3790408,15.7856682 57.9393619,15.7856682 C58.4996831,15.7856682 58.9540461,15.3442696 58.9540461,14.7999362 C58.9540461,14.2556028 58.4996831,13.8142043 57.9393619,13.8142043 C57.3790408,13.8142043 56.9246778,14.2556028 56.9246778,14.7999362 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8956265,24.0187106 C42.9417917,24.0187106 47.167547,22.8044284 51.3286499,20.4194806 C55.6298331,17.9542784 58.3111135,15.1593358 58.4224593,15.0424437 L55.2904078,15.0424437 C55.2634693,15.0703583 53.4711599,16.9580785 49.2777308,19.3569837 C45.4362983,21.5535084 41.0794422,24.1792192 34.6483203,22.6596218 C24.9881682,20.3776088 14.040355,0.975263981 13.930805,0.779862253 L10.7987534,0.779862253 C11.1579337,2.07788802 21.6118741,20.9795159 31.6581449,23.3539958 C33.1110289,23.6976935 37.37809,24.0221999 38.8938306,24.0221999 L38.8956265,24.0187106 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39256286,0.985731931 C9.39256286,1.53006532 9.84692584,1.97146386 10.407247,1.97146386 C10.9675681,1.97146386 11.4219311,1.53006532 11.4219311,0.985731931 C11.4219311,0.441398546 10.9675681,0 10.407247,0 C9.84692584,0 9.39256286,0.441398546 9.39256286,0.985731931 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7926262,14.7999362 C53.7926262,15.3442696 54.2469892,15.7856682 54.8073104,15.7856682 C55.3676315,15.7856682 55.8219945,15.3442696 55.8219945,14.7999362 C55.8219945,14.2556028 55.3676315,13.8142043 54.8073104,13.8142043 C54.2469892,13.8142043 53.7926262,14.2556028 53.7926262,14.7999362 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7635749,24.0187106 C39.8097401,24.0187106 44.0354955,22.8044284 48.1965984,20.4194806 C52.4977815,17.9542784 55.1790619,15.1593358 55.2904078,15.0424437 L52.1601521,15.0424437 C52.1332136,15.0703583 50.6210649,16.5934449 46.4276357,18.9923501 C42.5862033,21.1906195 37.9491866,24.1774745 31.5180647,22.6578771 C21.8579125,20.3758641 10.9100993,0.973519323 10.8005493,0.778117595 L7.67029368,0.778117595 C8.12465667,1.59112836 18.4008029,20.7910928 28.4470737,23.1655727 C29.8999577,23.5092704 34.2496303,24.0204553 35.7653708,24.0204553 L35.7635749,24.0187106 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2623072,0.985731931 C6.2623072,1.53006532 6.71667019,1.97146386 7.27699134,1.97146386 C7.83731249,1.97146386 8.29167547,1.53006532 8.29167547,0.985731931 C8.29167547,0.441398546 7.83731249,0 7.27699134,0 C6.71667019,0 6.2623072,0.441398546 6.2623072,0.985731931 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6623706,14.7999362 C50.6623706,15.3442696 51.1167336,15.7856682 51.6770547,15.7856682 C52.2373759,15.7856682 52.6917389,15.3442696 52.6917389,14.7999362 C52.6917389,14.2556028 52.2373759,13.8142043 51.6770547,13.8142043 C51.1167336,13.8142043 50.6623706,14.2556028 50.6623706,14.7999362 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6333192,24.0187106 C36.6794845,24.0187106 40.9052398,22.8044284 45.0663427,20.4194806 C49.3675259,17.9542784 52.0488063,15.1593358 52.1601521,15.0424437 L49.0281006,15.0424437 C49.0011621,15.0703583 46.8855905,16.9423766 42.6921614,19.3412817 C38.8507289,21.5395512 34.817135,24.1774745 28.3842172,22.6578771 C18.7240651,20.3758641 7.77625185,0.973519323 7.66670188,0.778117595 L4.53465033,0.778117595 C4.98901331,1.59112836 15.3136488,21.1557264 25.3599197,23.5284616 C26.8128037,23.8721593 31.1139869,24.0187106 32.6297274,24.0187106 L32.6333192,24.0187106 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13025565,0.985731931 C3.13025565,1.53006532 3.58461864,1.97146386 4.14493978,1.97146386 C4.70526093,1.97146386 5.15962392,1.53006532 5.15962392,0.985731931 C5.15962392,0.441398546 4.70526093,0 4.14493978,0 C3.58461864,0 3.13025565,0.441398546 3.13025565,0.985731931 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.530319,14.7999362 C47.530319,15.3442696 47.984682,15.7856682 48.5450032,15.7856682 C49.1053243,15.7856682 49.5596873,15.3442696 49.5596873,14.7999362 C49.5596873,14.2556028 49.1053243,13.8142043 48.5450032,13.8142043 C47.984682,13.8142043 47.530319,14.2556028 47.530319,14.7999362 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5012677,24.0187106 C33.5474329,24.0187106 37.7731883,22.8044284 41.9342911,20.4194806 C46.2354743,17.9542784 48.9167547,15.1593358 49.0281006,15.0424437 L45.8978449,15.0424437 C45.8709064,15.0703583 43.7732939,16.9737805 40.2982252,19.1528586 C36.5537714,21.5011687 31.6850835,24.1792192 25.2539615,22.6578771 C15.5938094,20.3758641 4.6459962,0.973519323 4.53644623,0.778117595 L1.40619058,0.778117595 C1.86055356,1.59112836 11.9948236,20.6759453 22.0392985,23.0486806 C23.4921825,23.3923783 27.9855271,24.0187106 29.4994718,24.0187106 L29.5012677,24.0187106 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.371012,24.0187106 C30.4171773,24.0187106 34.6429326,22.8044284 38.8040355,20.4194806 C43.1052187,17.9542784 45.786499,15.1593358 45.8978449,15.0424437 L45.2387492,14.4510046 C45.2118107,14.4789191 42.5197549,17.282585 38.3263258,19.6814901 C34.4848933,21.8797595 28.5566237,24.1792192 22.1255018,22.6596218 C12.4653497,20.3776088 1.51753645,0.975263981 1.40798648,0.779862253 L0.619585886,1.19683558 C1.07394887,2.00984634 11.8673146,21.1347905 21.9135855,23.5075257 C23.3664695,23.8512234 24.8570674,24.0204553 26.3728079,24.0204553 L26.371012,24.0187106 Z",
    id: "Path",
    fill: "#DB1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.814494,1.12210339 C20.814494,1.45919057 20.7498415,1.77322906 20.6402916,2.0325269 L1.52651595,2.0325269 L1.52651595,0.776372937 L20.7911473,0.776372937 C20.8055145,0.885854246 20.814494,1.00109773 20.814494,1.1192223 L20.814494,1.12210339 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1531798,23.2528056 C32.5183816,22.8742148 36.7531164,20.9987071 36.7531164,20.9987071 L36.8051975,20.7841141 C36.9093598,20.8521558 37.0117262,20.9184528 37.1158884,20.9830052 C38.2598775,20.4037786 39.3176632,19.7669784 40.3000211,19.151114 C42.8106909,17.5756876 44.6030002,16.1450678 45.4147475,15.4629064 L45.4147475,14.7999362 L65.2163533,14.7999362 C65.2163533,15.3442696 64.7619903,15.7856682 64.2016691,15.7856682 L63.9215086,15.7856682 C62.8260089,16.8010593 60.608071,18.6905242 57.592753,20.4194806 C53.4316501,22.8044284 49.2058948,24.0187106 45.1597296,24.0187106 C44.6658568,24.0187106 44.1755757,23.9925407 43.6870906,23.9489243 C43.1321572,23.9942854 42.5790196,24.0187106 42.027678,24.0187106 C41.6505388,24.0187106 41.118952,23.9942854 40.5119375,23.9541582 C39.9713712,23.99603 39.4326009,24.0187106 38.8974224,24.0187106 C38.5130995,24.0187106 37.9509825,23.9977747 37.3026622,23.9611369 C36.7872385,23.9995194 36.2754067,24.0187106 35.7671667,24.0187106 C35.4187619,24.0187106 34.9177055,23.9907961 34.3376294,23.945435 C33.7665329,23.9925407 33.1990281,24.0187106 32.6351151,24.0187106 C32.1897317,24.0187106 31.5036974,24.006498 30.7188887,23.9785835 C30.313015,24.0030087 29.9071413,24.0187106 29.5030636,24.0187106 C28.6356434,24.0187106 26.7966406,23.8128409 25.1084936,23.5738227 C26.3153391,23.5668441 28.5207057,23.5127597 30.1549757,23.2528056 L30.1531798,23.2528056 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1998732,16.0560902 L61.0696176,16.0560902 C61.0696176,16.0560902 57.937566,16.0560902 57.937566,16.0560902 L54.8073104,16.0560902 C54.8073104,16.0560902 51.6752588,16.0560902 51.6752588,16.0560902 L48.5450032,16.0560902 C48.5450032,16.0560902 45.4129516,16.0560902 45.4129516,16.0560902 L45.4129516,14.7999362 L65.2145574,14.7999362 C65.2145574,15.4936 64.7601944,16.0560902 64.1998732,16.0560902 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.371012,24.0187106 C30.4171773,24.0187106 34.6429326,22.8044284 38.8040355,20.4194806 C43.1052187,17.9542784 45.786499,15.1593358 45.8978449,15.0424437 L45.2387492,14.4510046 C45.2118107,14.4789191 42.5197549,17.282585 38.3263258,19.6814901 C34.4848933,21.8797595 28.5566237,24.1792192 22.1255018,22.6596218 C12.4653497,20.3776088 1.51753645,0.975263981 1.40798648,0.779862253 L0.619585886,1.19683558 C1.07394887,2.00984634 11.8673146,21.1347905 21.9135855,23.5075257 C23.3664695,23.8512234 24.8570674,24.0204553 26.3728079,24.0204553 L26.371012,24.0187106 Z",
    id: "Path",
    fill: "#106275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.985731931 C0,1.53006532 0.454362983,1.97146386 1.01468413,1.97146386 C1.57500528,1.97146386 2.02936827,1.53006532 2.02936827,0.985731931 C2.02936827,0.441398546 1.57500528,0 1.01468413,0 C0.454362983,0 0,0.441398546 0,0.985731931 Z",
    id: "Path",
    fill: "#D61A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4000634,14.7999362 C44.4000634,15.3442696 44.8544264,15.7856682 45.4147475,15.7856682 C45.9750687,15.7856682 46.4294317,15.3442696 46.4294317,14.7999362 C46.4294317,14.2556028 45.9750687,13.8142043 45.4147475,13.8142043 C44.8544264,13.8142043 44.4000634,14.2556028 44.4000634,14.7999362 Z",
    id: "Path",
    fill: "#D61A1A"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.7982, 1.6133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5850412,14.7999362 C44.5850412,15.3442696 45.0394042,15.7856682 45.5997253,15.7856682 C46.1600465,15.7856682 46.6144095,15.3442696 46.6144095,14.7999362 C46.6144095,14.2556028 46.1600465,13.8142043 45.5997253,13.8142043 C45.0394042,13.8142043 44.5850412,14.2556028 44.5850412,14.7999362 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.184977815,0.985731931 C0.184977815,1.53006532 0.639340799,1.97146386 1.19966195,1.97146386 C1.7599831,1.97146386 2.21434608,1.53006532 2.21434608,0.985731931 C2.21434608,0.441398546 1.7599831,0 1.19966195,0 C0.639340799,0 0.184977815,0.441398546 0.184977815,0.985731931 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF1B1B",
    x: 0,
    y: 0.382080164,
    width: 1.29304881,
    height: 1.25615396
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#7A4315",
    transform: "translate(10.5181, 19.5923) rotate(-80.42) translate(-10.5181, -19.5923)",
    points: "0.913385337 18.9000335 20.1167464 18.9925172 20.122801 20.2845441 0.919439915 20.1920604"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#613511",
    points: "12.1633529 12.7302582 11.321845 12.1510316 11.7342025 9.86727392 12.2044021 9.94229423 12.6148938 10.2249289"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8C4D18",
    transform: "translate(25.3861, 23.45) rotate(-18.87) translate(-25.3861, -23.45)",
    points: "1.65570428 22.104704 49.0960888 22.5202076 49.1164758 24.7952315 1.67609132 24.3797279"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 5.04337464,
    cy: 30.1907983,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7A4315",
    points: "27.3915682 23.9815594 25.1035901 22.34507 27.7920541 21.4518049 30.0800322 23.0900391"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8C4D18",
    transform: "translate(21.3681, 16.2878) rotate(-53.63) translate(-21.3681, -16.2878)",
    points: "19.8725212 -9.14829598 22.1640021 -9.11648805 22.8636786 41.7238196 20.5721977 41.6920116"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 41.0062946,
    cy: 30.3216477,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 41.8144501,
    cy: 30.3216477,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#703E13",
    transform: "translate(11.3261, 19.5928) rotate(-80.42) translate(-11.3261, -19.5928)",
    points: "1.72134518 18.9005143 20.9247062 18.992998 20.9307608 20.2850249 1.72739976 20.1925413"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#542E0F",
    points: "12.9726518 12.7302582 12.1317964 12.7302582 12.5428812 9.86727392 13.0137603 9.94229423 13.4248452 10.2249289"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7A4315",
    points: "4.05922083 31.9982643 49.0860537 17.0465428 48.3317752 14.9006131 3.30494236 29.8505899 3.25106532 31.9982643"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 5.85153014,
    cy: 30.1907983,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#703E13",
    points: "28.1997237 23.9815594 27.3915682 23.9815594 25.9117457 22.34507 28.6002096 21.4518049 30.8881877 23.0900391"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9C561B",
    points: "0.806843899 2.41060442 42.1592631 31.9982643 43.5421069 30.171607 32.7720879 22.4637067 31.9639324 22.4637067 32.3267045 22.1461789 2.19148366 0.583947192 1.38332816 0.583947192"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#7A4315",
    transform: "translate(10.5181, 19.5923) rotate(-80.42) translate(-10.5181, -19.5923)",
    points: "0.913385337 18.9000335 20.1167464 18.9925172 20.122801 20.2845441 0.919439915 20.1920604"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#613511",
    points: "12.1633529 12.7302582 11.321845 12.1510316 11.7342025 9.86727392 12.2044021 9.94229423 12.6148938 10.2249289"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8C4D18",
    transform: "translate(25.3861, 23.45) rotate(-18.87) translate(-25.3861, -23.45)",
    points: "1.65570428 22.104704 49.0960888 22.5202076 49.1164758 24.7952315 1.67609132 24.3797279"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 5.04337464,
    cy: 30.1907983,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7A4315",
    points: "27.3915682 23.9815594 25.1035901 22.34507 27.7920541 21.4518049 30.0800322 23.0900391"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8C4D18",
    transform: "translate(21.3681, 16.2878) rotate(-53.63) translate(-21.3681, -16.2878)",
    points: "19.8725212 -9.14829598 22.1640021 -9.11648805 22.8636786 41.7238196 20.5721977 41.6920116"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E3411",
    cx: 41.0062946,
    cy: 30.3216477,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9C561B",
    points: "48.3317752 14.9006131 47.5236197 14.9006131 48.2778982 17.0465428 49.0860537 17.0465428"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7A4315",
    points: "43.5421069 30.171607 42.7339514 30.171607 41.3511076 31.9982643 42.1592631 31.9982643"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5146, 52.1267)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.979, 0.0004)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0, 0)",
    fill: "#A16F31",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(3.8789, 4.7803) rotate(-53.21) translate(-3.8789, -4.7803)",
    points: "-1.08900121 3.651808 8.81750445 3.78990311 8.84679959 5.90870965 -1.05970607 5.77061454"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(6.9094, 1.1598) rotate(-53.21) translate(-6.9094, -1.1598)",
    points: "6.26002994 0.0915228763 7.52941668 0.109217925 7.55871182 2.22802447 6.28932508 2.21032942"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.15737344,7.62635675 C0.943520758,7.90386775 1.00292428,8.29932091 1.28806119,8.50514157 C1.57319809,8.71327481 1.97951818,8.65546002 2.19337086,8.37794903 C2.40722354,8.10043803 2.34782002,7.70498487 2.06268311,7.49916421 C1.77754621,7.29103097 1.37122612,7.34884576 1.15974958,7.62635675 L1.15737344,7.62635675 Z",
    id: "Path",
    fill: "#BE7A2F"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C4883C",
    transform: "translate(16.4234, 4.7803) rotate(-53.21) translate(-16.4234, -4.7803)",
    points: "11.4555358 3.65183082 21.3620415 3.78992593 21.3913366 5.90873248 11.484831 5.77063737"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C4883C",
    transform: "translate(19.4528, 1.1612) rotate(-53.21) translate(-19.4528, -1.1612)",
    points: "18.8034914 0.0929428856 20.0728782 0.110637935 20.1021733 2.22944448 18.8327866 2.21174943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7002253,7.62672451 C13.4859789,7.90423551 13.5454918,8.29968867 13.8311536,8.50550933 C14.1168155,8.71364257 14.5238836,8.65582778 14.7357495,8.37831679 C14.9499958,8.10080579 14.890483,7.70535263 14.6048211,7.49953197 C14.3191593,7.29139873 13.9120911,7.34921352 13.6978447,7.62672451 L13.7002253,7.62672451 Z",
    id: "Path",
    fill: "#C4883C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#453021",
    points: "6.91242341 17.2877492 21.2077963 17.2877492 22.3320304 8.68134991 5.78818931 8.68134991"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A8631F",
    x: 15.7608282,
    y: 8.68134991,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A8631F",
    x: 8.96154659,
    y: 8.68134991,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A35714",
    points: "21.8467044 12.9836772 20.8593915 12.9836772 20.8593915 10.8325136 22.1524403 10.8325136"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A66B29",
    x: 5.55292626,
    y: 7.23328354,
    width: 17.0161631,
    height: 1.44806638
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#332318",
    x: 5.78818931,
    y: 7.00298864,
    width: 16.5438411,
    height: 1.25615396
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BD934E",
    x: 5.55292626,
    y: 6.35572042,
    width: 17.0161631,
    height: 1.25615396
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A35714",
    x: 7.26082823,
    y: 10.8325136,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A35714",
    x: 14.0601099,
    y: 10.8325136,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A8631F",
    x: 15.7608282,
    y: 12.9836772,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A8631F",
    x: 8.96154659,
    y: 12.9836772,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A35714",
    points: "22.1524403 15.1365856 21.5740681 17.2877492 20.8593915 17.2877492 20.8593915 15.1365856"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A35714",
    x: 7.26082823,
    y: 15.1365856,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A35714",
    x: 14.0601099,
    y: 15.1365856,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.7882, 8.6813)",
    fill: "#AD6F2B"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.3722797 2.15116367 13.3722797 0 16.5438411 0 16.2636805 2.15116367"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.280160575 2.15116367 0 0 3.17335728 0 3.17335728 2.15116367"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.5729981,
    y: 0,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 11.6715614,
    y: 2.15116367,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.280160575 2.15116367 1.57320938 2.15116367 1.57320938 4.30232733 0.585896512 4.30232733"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.87227974,
    y: 2.15116367,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "15.7015635 6.45523565 13.3722797 6.45523565 13.3722797 4.30232733 15.9817241 4.30232733"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.56211705 4.30232733 3.17335728 4.30232733 3.17335728 6.45523565 0.844073526 6.45523565"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.5729981,
    y: 4.30232733,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 11.6715614,
    y: 6.45523565,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2.13712233 6.45523565 2.13712233 8.60639932 1.42040385 8.60639932 0.844073526 6.45523565"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.87227974,
    y: 6.45523565,
    width: 3.39964082,
    height: 2.15116367
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.3,
    points: "22.2530108 9.29103133 14.7551236 9.29103133 14.2594549 9.93750388 13.3722797 9.29103133 5.86720896 9.29103133 5.78818931 8.68134991 22.3320304 8.68134991"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.1,
    points: "19.0616945 3.08623079 16.3893936 3.08623079 17.3915064 1.78471571 20.0638073 1.78471571"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#453021",
    points: "1.36129305 17.2877492 15.656666 17.2877492 16.7809001 8.68134991 0.237058948 8.68134991"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.2371, 8.6813)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE7A2F",
    points: "13.3722797 2.15116367 13.3722797 0 16.5438411 0 16.2636805 2.15116367"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B86C22",
    x: 9.97263892,
    y: 0,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE7A2F",
    points: "0.280160575 2.15116367 0 0 3.17335728 0 3.17335728 2.15116367"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BE7A2F",
    x: 6.5729981,
    y: 0,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B86C22",
    x: 3.17335728,
    y: 0,
    width: 3.39964082,
    height: 2.15116367
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B15F15",
    points: "16.295574 12.9836772 15.3082611 12.9836772 15.3082611 10.8325136 16.60131 10.8325136"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BE7A2F",
    x: 0,
    y: 7.23328354,
    width: 17.0161631,
    height: 1.44806638
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#453021",
    x: 0.237058948,
    y: 7.00298864,
    width: 16.5438411,
    height: 1.25615396
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D1A356",
    x: 0,
    y: 6.35572042,
    width: 17.0161631,
    height: 1.25615396
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BE7A2F",
    x: 11.9086203,
    y: 10.8325136,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B15F15",
    x: 1.70969787,
    y: 10.8325136,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE7A2F",
    points: "0.517219523 10.8325136 1.81026833 10.8325136 1.81026833 12.9836772 0.82295546 12.9836772"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B15F15",
    x: 8.50897951,
    y: 10.8325136,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BE7A2F",
    x: 5.10933869,
    y: 10.8325136,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE7A2F",
    points: "15.9386224 15.1365856 13.6093387 15.1365856 13.6093387 12.9836772 16.218783 12.9836772"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B86C22",
    x: 10.2096979,
    y: 12.9836772,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE7A2F",
    points: "0.799175998 12.9836772 3.41041623 12.9836772 3.41041623 15.1365856 1.08113247 15.1365856"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BE7A2F",
    x: 6.81005705,
    y: 12.9836772,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B86C22",
    x: 3.41041623,
    y: 12.9836772,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B15F15",
    points: "16.60131 15.1365856 16.0229377 17.2877492 15.3082611 17.2877492 15.3082611 15.1365856"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BE7A2F",
    x: 11.9086203,
    y: 15.1365856,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B15F15",
    x: 1.70969787,
    y: 15.1365856,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE7A2F",
    points: "2.37418128 15.1365856 2.37418128 17.2877492 1.6574628 17.2877492 1.08113247 15.1365856"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B15F15",
    x: 8.50897951,
    y: 15.1365856,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.3,
    points: "8.96154659 6.35572042 11.6356434 6.35572042 9.84512994 8.68134991 7.17282907 8.68134991"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BE7A2F",
    x: 5.10933869,
    y: 15.1365856,
    width: 3.39964082,
    height: 2.15116367
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.3,
    points: "16.7018804 9.29103133 9.20399324 9.29103133 8.70832453 9.93750388 7.82114938 9.29103133 0.316078597 9.29103133 0.237058948 8.68134991 16.7809001 8.68134991"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.9931, 0.0056)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    fill: "#A16F31",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(3.8789, 4.7736) rotate(-53.21) translate(-3.8789, -4.7736)",
    points: "-1.08900121 3.64517684 8.81750445 3.78327195 8.84679959 5.90207849 -1.05970607 5.76398338"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(6.9083, 1.1598) rotate(-53.21) translate(-6.9083, -1.1598)",
    points: "6.25895441 0.0915228763 7.52834115 0.109217925 7.55763628 2.22802447 6.28824955 2.21032942"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.15572089,7.6211456 C0.941868212,7.8986566 1.00127173,8.29410976 1.28640864,8.49993042 C1.57154555,8.70806366 1.97786564,8.65024887 2.19171832,8.37273788 C2.405571,8.09522688 2.34616747,7.69977372 2.06103057,7.49395306 C1.77589366,7.28581982 1.36957357,7.34363461 1.15572089,7.6211456 Z",
    id: "Path",
    fill: "#BE7A2F"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C4883C",
    transform: "translate(10.4365, 4.7768) rotate(-53.21) translate(-10.4365, -4.7768)",
    points: "5.46857849 3.64831868 15.3750842 3.78641379 15.4043793 5.90522034 5.49787363 5.76712522"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C4883C",
    transform: "translate(13.467, 1.1598) rotate(-53.21) translate(-13.467, -1.1598)",
    points: "12.8176096 0.0915228763 14.0869964 0.109217925 14.1162915 2.22802447 12.8469048 2.21032942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71448683,7.62672451 C7.50024045,7.90423551 7.55975333,8.29968867 7.84541518,8.50550933 C8.13107702,8.71364257 8.53814515,8.65582778 8.75001102,8.37831679 C8.96425741,8.10080579 8.90474452,7.70535263 8.61908268,7.49953197 C8.33342083,7.29139873 7.9263527,7.34921352 7.71448683,7.62672451 Z",
    id: "Path",
    fill: "#BE7A2F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A16F31",
    points: "20.2595605 2.7303205 13.8374181 2.7303205 14.3169237 1.47416654 20.7390661 1.47416654"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D19040",
    points: "19.0239806 0.228480523 12.6018382 0.228480523 14.3169237 1.48463449 20.7390661 1.48463449"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A16F31",
    points: "14.2738221 2.09526489 13.8374181 2.09526489 8.27371646 9.32512882 8.70832453 9.32512882"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.953, 55.6368)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60173252,0.699607972 L10.0121487,0.699607972 C10.7448764,0.699607972 11.3429115,1.27883452 11.3429115,1.99239976 C11.3429115,2.07788802 11.2710754,2.14767435 11.1830763,2.14767435 L11.0914853,2.14767435 L11.0914853,2.11801516 C11.0501796,2.09010063 11.0232411,2.04299485 11.0232411,1.9906551 C11.0232411,1.44981103 10.570674,1.00841249 10.0121487,1.00841249 L6.60173252,1.00841249 C6.51373336,1.00841249 6.44189732,0.938626157 6.44189732,0.853137901 C6.44189732,0.767649645 6.51373336,0.697863314 6.60173252,0.697863314 L6.60173252,0.699607972 Z",
    fill: "#7A8FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33319248,1.96797455 L3.56306782,1.96797455 C3.56306782,1.41401845 3.8557997,0.961490933 4.21677583,0.961490933 C4.57775195,0.961490933 4.87048384,1.4120679 4.87048384,1.96797455 L5.10035918,1.96797455 C5.10035918,1.27552942 4.70346503,0.71182058 4.21677583,0.71182058 C3.73008663,0.71182058 3.33319248,1.27552942 3.33319248,1.96797455 Z",
    fill: "#A3BFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51552926,0.699607972 L9.92594549,0.699607972 C10.6586731,0.699607972 11.2567082,1.27883452 11.2567082,1.99239976 C11.2567082,2.07788802 11.1848722,2.14767435 11.096873,2.14767435 C11.0088739,2.14767435 10.9370378,2.07788802 10.9370378,1.99239976 C10.9370378,1.45155569 10.4844707,1.01015715 9.92594549,1.01015715 L6.51552926,1.01015715 C6.42753011,1.01015715 6.35569406,0.940370815 6.35569406,0.854882559 C6.35569406,0.769394304 6.42753011,0.699607972 6.51552926,0.699607972 L6.51552926,0.699607972 Z",
    fill: "#A3BFD6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.1544, 0)",
    fill: "#0E0E1A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.46101838,1.11832596 C4.46101838,2.07265404 5.28174519,2.84553766 6.29463342,2.84553766 C7.30752166,2.84553766 8.12824847,2.07265404 8.12824847,1.11832596 C8.12824847,0.163997879 7.30752166,0 6.29463342,0 C5.28174519,0 4.46101838,0.16225322 4.46101838,1.11832596 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.11832596 C0,2.07265404 0.820726812,2.84553766 1.83361504,2.84553766 C2.84650327,2.84553766 3.66723009,2.07265404 3.66723009,1.11832596 C3.66723009,0.163997879 2.84650327,0 1.83361504,0 C0.820726812,0 0,0.16225322 0,1.11832596 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#191A2E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.46101838,1.11832596 C4.46101838,2.07265404 5.28174519,2.84553766 6.29463342,2.84553766 C7.30752166,2.84553766 8.12824847,2.07265404 8.12824847,1.11832596 C8.12824847,0.163997879 7.30752166,0 6.29463342,0 C5.28174519,0 4.46101838,0.16225322 4.46101838,1.11832596 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.11832596 C0,2.07265404 0.820726812,2.84553766 1.83361504,2.84553766 C2.84650327,2.84553766 3.66723009,2.07265404 3.66723009,1.11832596 C3.66723009,0.163997879 2.84650327,0 1.83361504,0 C0.820726812,0 0,0.16225322 0,1.11832596 L0,1.11832596 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.97200507,1.81269996 C7.68825269,2.4215857 7.04352419,2.84728232 6.29283752,2.84728232 C5.40386647,2.84728232 4.66215931,2.25060919 4.4951405,1.45678967 C5.76125079,1.51261873 6.93936193,1.63648947 7.97200507,1.81269996 Z",
    fill: "#0E0E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98119586,1.42364116 C3.2020917,1.42364116 3.41939573,1.42538582 3.63669977,1.43061979 C3.48045637,2.23665192 2.7333615,2.84728232 1.83361504,2.84728232 C0.933868582,2.84728232 0.260405662,2.2959703 0.0574688358,1.54925656 C0.975174308,1.46900228 1.95753222,1.42364116 2.98119586,1.42364116 L2.98119586,1.42364116 Z",
    fill: "#0E0E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28776674,0.105607623 L7.73853793,0.711148302 C7.84629199,0.856164516 7.82474118,1.06585012 7.6936404,1.18343084 C7.63617156,1.23438248 7.56792732,1.25789862 7.49968308,1.25789862 C7.40988802,1.25789862 7.32188887,1.21478569 7.26082823,1.13443887 L6.4203465,0.00174465828 C6.7400169,0.007623694 7.03634059,0.035059194 7.28956265,0.105607623 L7.28776674,0.105607623 Z",
    fill: "#46565C",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75913797,0.359399607 L6.0970843,1.96448523 C6.20483837,2.09358994 6.18328756,2.28026838 6.05218677,2.38494788 C5.99471794,2.43030899 5.9264737,2.45124489 5.85822945,2.45124489 C5.7684344,2.45124489 5.68043524,2.41286241 5.6193746,2.34133142 L4.46999789,0.961306715 C4.49873231,0.696118656 4.60109867,0.500716928 4.76093387,0.359399607 L4.75913797,0.359399607 Z",
    fill: "#617280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90671878,0.565269284 C6.0881048,0.422207305 6.35389816,0.450121837 6.50116205,0.626332324 L7.76727234,2.14592969 C7.59666174,2.36401198 7.3703782,2.54196712 7.11176843,2.66583786 L5.84386224,1.14449583 C5.69659835,0.968285348 5.72533277,0.710075922 5.90671878,0.567013943 L5.90671878,0.565269284 Z",
    fill: "#7A90A1",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83361504,0.00174465828 C2.10659201,0.00174465828 2.36520177,0.0150473478 2.59687302,0.0549554163 L3.11050074,0.727691428 C3.21825481,0.86831986 3.19670399,1.07166097 3.06560321,1.18568402 C3.00813438,1.23509401 2.93989013,1.25789862 2.87164589,1.25789862 C2.78185083,1.25789862 2.69385168,1.21609017 2.63279104,1.13627403 L1.7653708,0.00364504249 C1.78692161,0.00364504249 1.81026833,0.00364504249 1.83181914,0.00364504249 L1.83361504,0.00174465828 Z",
    fill: "#46565C",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.11832596 C0,0.837435977 0.0718360448,0.624587666 0.197549123,0.465823762 L1.47084302,1.99414442 C1.57859708,2.12324913 1.55704627,2.30992757 1.42594549,2.41460707 C1.36847665,2.45996818 1.30023241,2.48090408 1.23198817,2.48090408 C1.14219311,2.48090408 1.05419396,2.4425216 0.993133319,2.36924595 L0.00179590112,1.179389 C0.00179590112,1.1584531 0.00179590112,1.1375172 0.00179590112,1.1165813 L0,1.11832596 Z",
    fill: "#617280",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.2822734,0.596673133 C1.46365941,0.453611154 1.72945278,0.481525687 1.87671667,0.657736173 L3.2110712,2.25933248 C3.02070568,2.4634575 2.78185083,2.62396606 2.51066977,2.72515624 L1.21941686,1.17589968 C1.07215297,0.999689197 1.10088739,0.741479771 1.2822734,0.598417792 L1.2822734,0.596673133 Z",
    fill: "#7A90A1",
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.7409, 47.7047)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4C86BD",
    fillRule: "nonzero",
    x: 1.75907483,
    y: 10.0903175,
    width: 3.55408832,
    height: 1.25615396
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#5597D4",
    fillRule: "nonzero",
    points: "1.75907484 10.0903175 5.31316315 10.0903175 6.07462523 4.02239599 0.995816859 4.02239599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7092B3",
    fillRule: "nonzero",
    points: "5.79805645 4.02239599 5.0689206 9.82164013 2.00152149 9.82164013 1.27418153 4.02239599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7092B3",
    fillRule: "nonzero",
    points: "5.79805645 4.02239599 5.0689206 9.82164013 2.00152149 9.82164013 1.27418153 4.02239599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F7A016",
    fillRule: "nonzero",
    points: "5.67952698 4.96102215 5.0689206 9.82164013 2.00152149 9.82164013 1.39091511 4.96102215"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F79216",
    fillRule: "nonzero",
    points: "3.99676763 4.96102215 5.67952698 4.96102215 5.0689206 9.82164013 3.99676763 9.82164013"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E37F05",
    fillRule: "nonzero",
    points: "5.083089 4.96102215 5.99919738 4.96102215 5.18805975 9.82164013 4.70614857 9.82164013"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFAF36",
    fillRule: "nonzero",
    points: "1.97817477 4.96102215 3.27122358 4.96102215 3.27122358 9.82164013 2.46268232 9.82164013"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61276171,6.06539084 C4.61276171,6.41044548 4.90010589,6.69346782 5.25928612,6.69346782 C5.61846634,6.69346782 5.90581052,6.4143225 5.90581052,6.06539084 C5.90581052,5.71645918 5.61846634,5.43731386 5.25928612,5.43731386 C4.90010589,5.43731386 4.61276171,5.71645918 4.61276171,6.06539084 Z M4.72769939,6.17704897 C4.72769939,5.83096574 5.01797565,5.54897199 5.37422379,5.54897199 C5.73047193,5.54897199 6.02074819,5.83096574 6.02074819,6.17704897 C6.02074819,6.52313221 5.73047193,6.80512595 5.37422379,6.80512595 C5.01797565,6.80512595 4.72769939,6.52313221 4.72769939,6.17704897 Z",
    id: "Shape",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.24428506,6.9412093 C3.24428506,7.28626394 3.53162924,7.56928628 3.89080946,7.56928628 C4.24998969,7.56928628 4.53733387,7.29014096 4.53733387,6.9412093 C4.53733387,6.59227764 4.24998969,6.31313232 3.89080946,6.31313232 C3.53162924,6.31313232 3.24428506,6.59227764 3.24428506,6.9412093 Z M3.35922273,7.05286743 C3.35922273,6.70678419 3.649499,6.42479045 4.00574714,6.42479045 C4.36199528,6.42479045 4.65227154,6.70678419 4.65227154,7.05286743 C4.65227154,7.39895067 4.36199528,7.68094441 4.00574714,7.68094441 C3.649499,7.68094441 3.35922273,7.39895067 3.35922273,7.05286743 Z",
    id: "Shape",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35531401,9.07492638 C2.35531401,9.41998102 2.64265819,9.70300336 3.00183841,9.70300336 C3.36101863,9.70300336 3.64836281,9.42385804 3.64836281,9.07492638 C3.64836281,8.72599472 3.36101863,8.4468494 3.00183841,8.4468494 C2.64265819,8.4468494 2.35531401,8.72599472 2.35531401,9.07492638 Z M2.47025168,9.18658451 C2.47025168,8.84050128 2.76052794,8.55850753 3.11677608,8.55850753 C3.47302422,8.55850753 3.76330048,8.84050128 3.76330048,9.18658451 C3.76330048,9.53266775 3.47302422,9.81466149 3.11677608,9.81466149 C2.76052794,9.81466149 2.47025168,9.53266775 2.47025168,9.18658451 Z",
    id: "Shape",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72674861,5.86475514 C1.72674861,6.21128037 2.0165699,6.49283212 2.37327302,6.49283212 C2.72997614,6.49283212 3.01979742,6.21128037 3.01979742,5.86475514 C3.01979742,5.51822991 2.72997614,5.23667816 2.37327302,5.23667816 C2.0165699,5.23667816 1.72674861,5.51822991 1.72674861,5.86475514 Z M1.89197152,6.0252637 C1.89197152,5.67982136 2.1829075,5.39718672 2.53849592,5.39718672 C2.89408434,5.39718672 3.18502032,5.67982136 3.18502032,6.0252637 C3.18502032,6.37070604 2.89408434,6.65334068 2.53849592,6.65334068 C2.1829075,6.65334068 1.89197152,6.37070604 1.89197152,6.0252637 Z",
    id: "Shape",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13684792,7.98974893 C4.13684792,8.33627416 4.4266692,8.61782591 4.78337232,8.61782591 C5.14007544,8.61782591 5.42989672,8.33627416 5.42989672,7.98974893 C5.42989672,7.6432237 5.14007544,7.36167195 4.78337232,7.36167195 C4.4266692,7.36167195 4.13684792,7.6432237 4.13684792,7.98974893 Z M4.30207082,8.15025749 C4.30207082,7.80032889 4.5930068,7.52218051 4.94859522,7.52218051 C5.30418365,7.52218051 5.59511963,7.80481515 5.59511963,8.15025749 C5.59511963,8.49569983 5.30418365,8.77833447 4.94859522,8.77833447 C4.5930068,8.77833447 4.30207082,8.49569983 4.30207082,8.15025749 Z",
    id: "Shape",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4949506,6.81733856 C4.4949506,7.11881551 4.74062987,7.35748477 5.05096159,7.35748477 C5.3612933,7.35748477 5.60697257,7.11881551 5.60697257,6.81733856 C5.60697257,6.51586161 5.34836281,6.27719236 5.05096159,6.27719236 C4.75356036,6.27719236 4.4949506,6.51586161 4.4949506,6.81733856 Z",
    id: "Path",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41700849,5.71471453 C4.41700849,6.06364618 4.70613742,6.34279151 5.06754857,6.34279151 C5.42895973,6.34279151 5.7100573,6.06364618 5.7100573,5.71471453 C5.7100573,5.36578287 5.42092837,5.08663754 5.06754857,5.08663754 C4.71416878,5.08663754 4.41700849,5.36578287 4.41700849,5.71471453 Z",
    id: "Path",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97732964,9.02607595 C4.97732964,9.37151829 5.26826562,9.65415293 5.62385404,9.65415293 C5.97944247,9.65415293 6.27037845,9.37151829 6.27037845,9.02607595 C6.27037845,8.68063361 5.97944247,8.39799897 5.62385404,8.39799897 C5.26826562,8.39799897 4.97732964,8.68063361 4.97732964,9.02607595 Z",
    id: "Path",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFAF36",
    fillRule: "nonzero",
    cx: 4.17815364,
    cy: 9.20054178,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90306385,10.0903175 C2.90306385,10.4339823 3.19582962,10.7183945 3.54958825,10.7183945 C3.90334689,10.7183945 4.19611265,10.4339823 4.19611265,10.0903175 C4.19611265,9.74665274 3.90334689,9.46224052 3.54958825,9.46224052 C3.19582962,9.46224052 2.90306385,9.74665274 2.90306385,10.0903175 Z",
    id: "Path",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81223351,5.7618203 C1.81223351,6.01305109 2.01912132,6.22659727 2.29066157,6.22659727 C2.56220182,6.22659727 2.76908962,6.01305109 2.76908962,5.7618203 C2.76908962,5.51058951 2.54927133,5.29704333 2.29066157,5.29704333 C2.03205181,5.29704333 1.81223351,5.49802797 1.81223351,5.7618203 Z",
    id: "Path",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09881707,5.99560451 C3.09881707,6.34150198 3.38928456,6.62368149 3.74534147,6.62368149 C4.10139839,6.62368149 4.39186588,6.34150198 4.39186588,5.99560451 C4.39186588,5.64970704 4.10139839,5.36752753 3.74534147,5.36752753 C3.38928456,5.36752753 3.09881707,5.64970704 3.09881707,5.99560451 Z",
    id: "Path",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51514921,7.34945934 C2.51514921,7.69204678 2.80062751,7.97753632 3.16167361,7.97753632 C3.5227197,7.97753632 3.80819801,7.70020363 3.80819801,7.34945934 C3.80819801,7.00687189 3.5227197,6.72138236 3.16167361,6.72138236 C2.80062751,6.72138236 2.51514921,6.99871505 2.51514921,7.34945934 Z",
    id: "Path",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3035498,8.30204276 C3.3035498,8.61608125 3.56215956,8.86731205 3.88542176,8.86731205 C4.20868396,8.86731205 4.46729372,8.61608125 4.46729372,8.30204276 C4.46729372,7.98800427 4.20868396,7.73677348 3.88542176,7.73677348 C3.56215956,7.73677348 3.3035498,7.98800427 3.3035498,8.30204276 Z",
    id: "Path",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45144754,6.77546676 C4.24819379,6.54691653 3.33767192,5.51756814 3.33767192,4.28060542 C3.33767192,4.1933725 3.34305962,4.10613959 3.35203913,4.02239599 L5.79805645,4.02239599 C5.79805645,4.02239599 5.45144754,6.77546676 5.45144754,6.77546676 L5.45144754,6.77546676 Z",
    id: "Path",
    fill: "#A15A0E",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06976573,8.51663573 C2.06976573,8.8643212 2.35839269,9.14471271 2.71629013,9.14471271 C3.07418757,9.14471271 3.36281453,8.8643212 3.36281453,8.51663573 C3.36281453,8.16895026 3.07418757,7.88855875 2.71629013,7.88855875 C2.35839269,7.88855875 2.06976573,8.16895026 2.06976573,8.51663573 Z",
    id: "Path",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    transform: "translate(2.9013, 8.4207)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.750686668,0 L1.53369956,0 C1.70790196,0 1.84977815,0.137828004 1.84977815,0.307059858 L1.84977815,1.06773087 C1.84977815,1.23696272 1.70790196,1.37479073 1.53369956,1.37479073 L0.750686668,1.37479073 C0.576484259,1.37479073 0.434608071,1.23696272 0.434608071,1.06773087 L0.434608071,0.307059858 C0.434608071,0.137828004 0.576484259,0 0.750686668,0 Z",
    fill: "#74ACC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30952884,0.646370487 C2.30952884,0.666696603 2.30952884,0.691087942 2.30952884,0.715479281 L2.30952884,1.25615396 C2.30952884,1.25615396 1.01648003,0.434978881 1.01648003,0.434978881 L1.14494709,0 L1.28737795,0 C1.28737795,0 2.30673608,0.646370487 2.30673608,0.646370487 L2.30952884,0.646370487 Z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6B9FB5",
    points: "2.21614198 1.5475119 0.923093176 0.844440649 1.11604813 0.291357934 2.21614198 0.888187305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.316078597,0 L1.09909149,0 C1.27329389,0 1.41517008,0.137828004 1.41517008,0.307059858 L1.41517008,1.06773087 C1.41517008,1.23696272 1.27329389,1.37479073 1.09909149,1.37479073 L0.316078597,1.37479073 C0.141876188,1.37479073 0,1.23696272 0,1.06773087 L0,0.307059858 C0,0.137828004 0.141876188,0 0.316078597,0 Z",
    fill: "#86C7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18600929,1.39546785 L1.5598616,1.39546785 C1.74164299,1.39546785 1.88569618,1.30932013 1.88569618,1.20514149 L1.88569618,0.331643679 C1.88569618,0.225461606 1.73821316,0.141317321 1.5598616,0.141317321 L0.819016657,0.141317321 C0.692112662,0.141317321 0.59264737,0.199416946 0.59264737,0.273544054 C0.59264737,0.347671162 0.692112662,0.405770787 0.819016657,0.405770787 L1.43638744,0.405770787 L1.43638744,1.13301782 L1.18943913,1.13301782 C1.06596497,1.13301782 0.963069839,1.19111744 0.963069839,1.26524455 C0.963069839,1.33937166 1.06596497,1.39747129 1.18943913,1.39747129 L1.18600929,1.39546785 Z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.514286479,1.39572663 C0.723207028,1.39572663 0.886955567,1.2528699 0.886955567,1.07060443 L0.886955567,0.789817068 L1.06764361,0.789817068 C1.27656416,0.789817068 1.4403127,0.646960343 1.4403127,0.464694865 C1.4403127,0.282429388 1.27656416,0.139572663 1.06764361,0.139572663 L0.683681519,0.139572663 C0.384416948,0.139572663 0.147263892,0.351394704 0.147263892,0.607551591 L0.147263892,1.07060443 C0.147263892,1.24794381 0.316658932,1.39572663 0.51993298,1.39572663 L0.514286479,1.39572663 Z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#779CBF",
    fillRule: "nonzero",
    points: "1.96837797 5.27854995 3.1401228 5.27854995 3.1401228 4.02239599 1.84707399 4.02239599"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    transform: "translate(3.1411, 6.569)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.930767541,0.342105004 L1.69445023,0.349734965 C1.86435211,0.351432456 2.0041083,0.494145444 2.00580579,0.667677824 L2.01343576,1.44767904 C2.01513325,1.62121142 1.87814204,1.76115942 1.70824016,1.75946193 L0.944557471,1.75183196 C0.774655588,1.75013447 0.634899397,1.60742148 0.633201906,1.43388911 L0.625571945,0.653887894 C0.623874453,0.480355514 0.760865658,0.340407512 0.930767541,0.342105004 Z",
    fill: "#74ACC4",
    transform: "translate(1.3195, 1.0508) rotate(-68.46) translate(-1.3195, -1.0508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68573133,1.258306 C2.68258523,1.27258047 2.67629302,1.28970985 2.67000081,1.30398432 L2.51584171,1.65799135 L1.39268253,0.635938806 L1.65066307,0.401837385 L1.79852996,0.456080398 L2.68258523,1.26116089 L2.68573133,1.258306 Z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6B9FB5",
    points: "2.22915656 1.91445612 1.14843997 0.979971486 1.52138247 0.658302153 2.44148878 1.45425766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.525374255,0.197151692 L1.28906227,0.204787348 C1.45896534,0.206486106 1.59872353,0.34919916 1.60042229,0.522730354 L1.60805794,1.30272624 C1.6097567,1.47625743 1.47276556,1.61620344 1.30286249,1.61450468 L0.539174477,1.60686902 C0.369271409,1.60517026 0.22951322,1.46245721 0.227814462,1.28892602 L0.220178806,0.508930133 C0.218480048,0.335398939 0.355471187,0.195452934 0.525374255,0.197151692 Z",
    fill: "#86C7E3",
    transform: "translate(0.9141, 0.9058) rotate(-68.44) translate(-0.9141, -0.9058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.942217454,1.55299433 L1.24382326,1.62754256 C1.39014687,1.66295298 1.55438765,1.61822403 1.61112538,1.52690244 L2.08891675,0.770237835 C2.14565447,0.678916244 2.07398577,0.576412418 1.92766216,0.539138299 L1.32743675,0.391905531 C1.22590608,0.367677353 1.11243063,0.397496648 1.07361008,0.46086265 C1.03478953,0.524228652 1.08256867,0.595049477 1.18409934,0.62114136 L1.68279408,0.744145952 L1.28563,1.37407856 L1.08555487,1.3237585 C0.984024199,1.29953032 0.870548748,1.32934961 0.828742003,1.39271562 C0.789921454,1.45608162 0.837700591,1.52690244 0.939231258,1.55299433 L0.942217454,1.55299433 Z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.668362868,1.47447847 C0.83240246,1.54337891 1.01574083,1.45857837 1.07846185,1.27837722 L1.17978042,0.997475434 L1.31969654,1.06107584 C1.48373614,1.12997628 1.66707451,1.04517574 1.73462022,0.864974592 C1.79734124,0.684773445 1.72014614,0.483372164 1.55610655,0.409171692 L1.24732614,0.27667085 C1.01091613,0.175970209 0.74555797,0.303171018 0.653888786,0.56287267 L0.485024499,1.0239756 C0.422303479,1.20417675 0.499498581,1.40557803 0.663538174,1.4797785 L0.668362868,1.47447847 Z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0, -0)",
    fillRule: "nonzero",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5EEF6",
    transform: "translate(2.3298, 5.011) rotate(-19.55) translate(-2.3298, -5.011)",
    points: "1.63908272 -0.00622274957 2.92800016 0.00541159234 3.02052549 10.0281808 1.73160805 10.0165464"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CFD7DE",
    transform: "translate(2.3405, 5.0664) rotate(-19.55) translate(-2.3405, -5.0664)",
    points: "1.64982783 0.0492116378 2.93874527 0.0608459797 3.0312706 10.0836152 1.74235316 10.0719808"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C93E47",
    transform: "translate(2.7346, 4.9585) rotate(-19.59) translate(-2.7346, -4.9585)",
    points: "2.04385703 -0.0588061873 3.33275821 -0.0471518677 3.42544242 9.97574661 2.13654124 9.96409229"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AB2E36",
    transform: "translate(2.4353, 5.0642) rotate(-19.53) translate(-2.4353, -5.0642)",
    points: "1.74457429 0.0470080746 3.03349985 0.0586324192 3.12594568 10.081337 1.83702012 10.0697127"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    transform: "translate(1.7626, 7.0398)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.936883052,0.270195899 L1.71347077,0.280308641 C1.88624372,0.282558494 2.02878807,0.423383047 2.03103793,0.594044354 L2.04115067,1.36114054 C2.04340052,1.53180184 1.90452088,1.66896169 1.73174793,1.66671184 L0.95516021,1.65659909 C0.782387254,1.65434924 0.639842905,1.51352469 0.637593052,1.34286338 L0.627480309,0.575767196 C0.625230456,0.405105889 0.764110096,0.267946045 0.936883052,0.270195899 Z",
    fill: "#74ACC4",
    transform: "translate(1.3343, 0.9685) rotate(-32.43) translate(-1.3343, -0.9685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.01546262,0.250302289 C2.01546262,0.250302289 2.03297005,0.305720846 2.04047323,0.336508934 L2.2180486,1.02616209 L0.970018903,1.50645625 L0.924999796,0.798330244 L1.03254544,0.632074572 L2.01796368,0.250302289 L2.01546262,0.250302289 Z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6B9FB5",
    points: "2.34735348 1.38224445 1.12061487 1.79781419 1.05430468 0.891116589 2.09758508 0.541660223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.573772531,0.493283036 L1.35034966,0.503400742 C1.52312025,0.5056517 1.66566358,0.646479072 1.66791454,0.817142735 L1.67803225,1.58424951 C1.6802832,1.75491317 1.54140638,1.89207404 1.36863579,1.88982308 L0.592058661,1.87970537 C0.419288062,1.87745442 0.276744733,1.73662704 0.274493775,1.56596338 L0.264376069,0.798856605 C0.262125111,0.628192942 0.401001932,0.491032078 0.573772531,0.493283036 Z",
    fill: "#86C7E3",
    transform: "translate(0.9712, 1.1916) rotate(-32.46) translate(-0.9712, -1.1916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.61574191,1.73450179 L1.81620845,1.61553581 C1.91208375,1.55810395 1.94041055,1.43708683 1.87939899,1.34478564 L1.3695167,0.589966997 C1.30850514,0.499716942 1.17994508,0.473052153 1.08406977,0.530484007 L0.685315675,0.76841597 C0.617767166,0.809438723 0.598156309,0.891484227 0.641735992,0.955069494 C0.685315675,1.01865476 0.772475041,1.037115 0.84002355,0.996092246 L1.17122914,0.799183035 L1.59613105,1.42683115 L1.46321302,1.50682551 C1.39566451,1.54784827 1.37605365,1.62989377 1.41963333,1.69347904 C1.46321302,1.7570643 1.55037238,1.77552454 1.61792089,1.73450179 L1.61574191,1.73450179 Z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25646272,2.06343038 C1.4542307,1.9762891 1.51164721,1.80200652 1.38405497,1.66693753 L1.18628699,1.45344137 L1.35853652,1.37937128 C1.5563045,1.29222999 1.61372101,1.11794742 1.49250838,0.982878425 C1.36491613,0.84780943 1.10973164,0.808595851 0.911963658,0.895737138 L0.541946146,1.05694852 C0.261243205,1.17894632 0.178308245,1.43601312 0.356937389,1.62772395 L0.675918004,1.97193203 C0.803510249,2.10700103 1.05869474,2.14621461 1.25646272,2.05907332 L1.25646272,2.06343038 Z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6583A1",
    fillRule: "nonzero",
    points: "6.09054994 5.27854995 4.98630915 5.27854995 5.07213097 4.02239599 6.27935795 4.02239599"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(3.4059, 1.552)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.6231, -0.7016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.0936188,3.172051 C1.0936188,1.9717261 1.99336526,0.979015539 3.17327229,0.788847786 L3.17327229,0.752209962 L3.58453365,0.752209962 C4.96019391,0.752209962 6.0754485,1.83564276 6.0754485,3.172051 C6.0754485,4.50845925 4.96019391,5.59189204 3.58453365,5.59189204 L3.17327229,5.59189204 L3.17327229,5.55525422 C1.99336526,5.36508647 1.0936188,4.37063124 1.0936188,3.172051 Z",
    id: "Path",
    fill: "#FF9500",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27138132,3.55805998 C6.27138132,3.27998009 6.49119961,3.04984501 6.81446181,2.93477748 C6.86618377,3.34710282 6.89204474,3.76901713 6.90497523,4.19093144 C6.54292156,4.09504183 6.2843118,3.85531779 6.2843118,3.54847102 L6.27138132,3.55805998 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82402235,3.29941106 C5.82402235,3.0607418 6.03091016,2.85975717 6.27658943,2.85975717 C6.5222687,2.85975717 6.72915651,3.0607418 6.72915651,3.29941106 C6.72915651,3.53808031 6.5222687,3.73906495 6.27658943,3.73906495 C6.03091016,3.73906495 5.82402235,3.53808031 5.82402235,3.29941106 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85814447,2.94175611 C5.85814447,3.18042536 6.06503228,3.38141 6.31071155,3.38141 C6.55639082,3.38141 6.76327863,3.18042536 6.76327863,2.94175611 C6.76327863,2.69052532 6.55639082,2.50210222 6.31071155,2.50210222 C6.06503228,2.50210222 5.85814447,2.70308686 5.85814447,2.94175611 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51638448,2.45674111 C5.51638448,2.74565652 5.76206376,2.98432577 6.0465345,2.98432577 C6.33100523,2.98432577 6.58961499,2.74565652 6.58961499,2.45674111 C6.58961499,2.16782569 6.34393572,1.92915644 6.0465345,1.92915644 C5.74913327,1.92915644 5.51638448,2.16782569 5.51638448,2.45674111 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41563443,2.02581051 C5.41563443,2.17654899 5.54493931,2.30216438 5.70010517,2.30216438 C5.85527103,2.30216438 5.98457591,2.17654899 5.98457591,2.02581051 C5.98457591,1.87507203 5.85527103,1.74945664 5.70010517,1.74945664 C5.54493931,1.74945664 5.41563443,1.87507203 5.41563443,2.02581051 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36660633,2.0962947 C5.04334413,2.0962947 4.78473437,1.84506391 4.78473437,1.53102542 C4.78473437,1.39284848 4.83645632,1.26723309 4.92696974,1.16674077 C5.26316243,1.33004079 5.58642463,1.51846388 5.90968683,1.70688698 C5.8321039,1.92043315 5.62521609,2.08373316 5.36660633,2.08373316 L5.36660633,2.0962947 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28493509,1.56522072 C4.28493509,1.90438229 4.56940582,2.1932977 4.93145949,2.1932977 C5.29351316,2.1932977 5.57798389,1.91694383 5.57798389,1.56522072 C5.57798389,1.21349761 5.29351316,0.93714374 4.93145949,0.93714374 C4.56940582,0.93714374 4.28493509,1.21349761 4.28493509,1.56522072 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04855224,1.26199911 C5.04855224,1.47554529 4.86752541,1.65140684 4.64770711,1.65140684 C4.42788882,1.65140684 4.24686198,1.47554529 4.24686198,1.26199911 C4.24686198,1.19919141 4.25979247,1.14894526 4.28565345,1.0986991 C4.54426321,1.14894526 4.78994248,1.19919141 5.04855224,1.26199911 C5.04855224,1.26199911 5.04855224,1.26199911 5.04855224,1.26199911 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76982839,1.98044939 C4.76982839,2.32697463 5.05964967,2.60852638 5.41635279,2.60852638 C5.77305591,2.60852638 6.0628772,2.32697463 6.0628772,1.98044939 C6.0628772,1.63392416 5.77305591,1.35237241 5.41635279,1.35237241 C5.05964967,1.35237241 4.76982839,1.63392416 4.76982839,1.98044939 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47561753,3.91876475 C5.47561753,4.26916559 5.76825489,4.54684173 6.12214193,4.54684173 C6.47602897,4.54684173 6.76866634,4.26255425 6.76866634,3.91876475 C6.76866634,3.57497524 6.47602897,3.29068777 6.12214193,3.29068777 C5.76825489,3.29068777 5.47561753,3.57497524 5.47561753,3.91876475 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64802404,4.41075838 C5.64802404,4.75234411 5.93158737,5.03883537 6.29454844,5.03883537 C6.65750951,5.03883537 6.94107284,4.76336301 6.94107284,4.41075838 C6.94107284,4.05815376 6.65750951,3.7826814 6.29454844,3.7826814 C5.93158737,3.7826814 5.64802404,4.05815376 5.64802404,4.41075838 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64443223,4.77015799 C5.64443223,5.08419648 5.903042,5.33542728 6.2263042,5.33542728 C6.5495664,5.33542728 6.80817616,5.08419648 6.80817616,4.77015799 C6.80817616,4.4561195 6.5495664,4.20488871 6.2263042,4.20488871 C5.903042,4.20488871 5.64443223,4.4561195 5.64443223,4.77015799 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33298072,4.52416117 C6.47521609,4.52416117 6.59159048,4.55938044 6.70796488,4.61807923 C6.41056365,5.01723095 6.08730145,5.40464292 5.75110876,5.78031514 C5.60887339,5.65117781 5.51835998,5.46334171 5.51835998,5.26376584 C5.51835998,4.85287436 5.88041364,4.52416117 6.33298072,4.52416117 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FA8C16",
    fillRule: "nonzero",
    cx: 5.91920511,
    cy: 5.1714294,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31829659,5.40695827 C5.31829659,5.63306598 5.51225391,5.82148907 5.7450027,5.82148907 C5.97775148,5.82148907 6.1717088,5.63306598 6.1717088,5.40695827 C6.1717088,5.18085055 5.97775148,4.99242746 5.7450027,4.99242746 C5.51225391,4.99242746 5.31829659,5.18085055 5.31829659,5.40695827 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72852266,5.43661746 C4.72852266,5.78251492 5.01899015,6.06469444 5.37504707,6.06469444 C5.73110398,6.06469444 6.02157147,5.78251492 6.02157147,5.43661746 C6.02157147,5.09071999 5.73110398,4.80854047 5.37504707,4.80854047 C5.01899015,4.80854047 4.72852266,5.09071999 4.72852266,5.43661746 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38347535,5.211731 C5.69073448,5.211731 5.94678375,5.42527718 6.01079606,5.71419259 C5.66512955,5.92773876 5.31946304,6.14128494 4.9481916,6.32970803 C4.8073645,6.21665418 4.71774726,6.04079262 4.71774726,5.85236953 C4.71774726,5.50064642 5.01220392,5.211731 5.37067289,5.211731 L5.38347535,5.211731 Z",
    id: "Path",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60352795,5.86580339 C4.60352795,6.09191111 4.79748527,6.2803342 5.03023405,6.2803342 C5.26298284,6.2803342 5.45694016,6.09191111 5.45694016,5.86580339 C5.45694016,5.63969568 5.26298284,5.45127259 5.03023405,5.45127259 C4.79748527,5.45127259 4.60352795,5.63969568 4.60352795,5.86580339 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09061859,5.95303631 C4.09061859,6.27963634 4.36215883,6.53086713 4.68542104,6.53086713 C5.00868324,6.53086713 5.28022349,6.2670748 5.28022349,5.95303631 C5.28022349,5.62643628 5.00868324,5.37520548 4.68542104,5.37520548 C4.36215883,5.37520548 4.09061859,5.63899782 4.09061859,5.95303631 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8891713,3.50528073 C6.82451886,3.93473508 6.73400544,4.35345307 6.61763105,4.7614347 C6.38488227,4.6325984 6.22971641,4.42860758 6.22971641,4.18167133 C6.22971641,3.84884421 6.51418715,3.58043525 6.8891713,3.50528073 L6.8891713,3.50528073 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11531751,3.77919209 C6.11531751,3.98017672 6.28341385,4.14347674 6.49030166,4.14347674 C6.69718947,4.14347674 6.86528582,3.98017672 6.86528582,3.77919209 C6.86528582,3.57820745 6.69718947,3.41490744 6.49030166,3.41490744 C6.28341385,3.41490744 6.11531751,3.57820745 6.11531751,3.77919209 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96697608,2.36061043 C5.96697608,2.23499504 6.00576754,2.12194118 6.05748949,2.02144886 C6.27730779,2.37317197 6.47126511,2.72489508 6.66522243,3.08917973 C6.27730779,3.05149512 5.96697608,2.75001816 5.96697608,2.36061043 L5.96697608,2.36061043 Z",
    id: "Path",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E07E14",
    fillRule: "nonzero",
    cx: 3.17327229,
    cy: 3.172051,
    rx: 2.49091485,
    ry: 2.41984104
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E16",
    fillRule: "nonzero",
    transform: "translate(3.1723, 3.1723) rotate(-45) translate(-3.1723, -3.1723)",
    cx: 3.17234148,
    cy: 3.17234148,
    r: 2.24318417
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.978681125,3.172051 C0.978681125,4.34969534 1.96103904,5.30402343 3.17327229,5.30402343 C4.38550555,5.30402343 5.36786346,4.34969534 5.36786346,3.172051 C5.36786346,1.99440666 4.38550555,1.04007858 3.17327229,1.04007858 C1.96103904,1.04007858 0.978681125,1.99440666 0.978681125,3.172051 Z",
    id: "Path",
    fill: "#F7E6B4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5418, 1.1517)",
    fill: "#F7A016",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.646539472,1.77082816 C0.700018078,1.77082816 0.747964414,1.73767965 0.766405312,1.69057388 L1.28643865,0.240762843 C1.30856773,0.177955145 1.27353002,0.109913472 1.20714279,0.0889775725 C1.02457789,0.0296591908 0.834636637,0 0.646539472,0 C0.458442308,0 0.268501054,0.0296591908 0.0859361595,0.0889775725 C0.0195489251,0.109913472 -0.015488782,0.177955145 0.00664029617,0.240762843 L0.526673632,1.69057388 C0.543270441,1.73942431 0.593060867,1.77082816 0.646539472,1.77082816 L0.646539472,1.77082816 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.64653214,4.04062859 C0.836471121,4.04062859 1.02456603,4.0109694 1.20712874,3.95165101 C1.27351518,3.93071512 1.30855247,3.86267344 1.28642366,3.79986574 L0.766396545,2.35005471 C0.747955868,2.30120428 0.700010105,2.26980043 0.64653214,2.26980043 C0.593054174,2.26980043 0.545108412,2.30294894 0.526667734,2.35005471 L0.00664062105,3.79986574 C-0.0154881923,3.86267344 0.0195490955,3.92897046 0.0840914677,3.95165101 C0.266654178,4.0109694 0.456593159,4.04062859 0.644688072,4.04062859 L0.64653214,4.04062859 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.368, 1.42)",
    fill: "#F7A016",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.98669238,1.57584002 C2.0244063,1.61247784 2.08007923,1.62120114 2.12856856,1.59852058 L3.54194275,0.921593163 C3.60300338,0.891933973 3.628146,0.820402983 3.59761568,0.76282926 C3.51500423,0.598831381 3.40725016,0.450535427 3.27614938,0.32492003 C3.1468445,0.199304634 2.9941929,0.0928804783 2.8253782,0.0126261972 C2.76431756,-0.0170329937 2.69068561,0.00739222231 2.6619512,0.066710604 L1.96514156,1.43975667 C1.94179485,1.48511779 1.95077435,1.54094685 1.98848828,1.57758468 L1.98669238,1.57584002 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.334463345,3.18092564 C0.463768226,3.3082857 0.616419821,3.41296519 0.785234526,3.49321948 C0.846295164,3.52287867 0.91992711,3.49845345 0.950457429,3.43913507 L1.64726706,2.066089 C1.67061378,2.02072788 1.66163427,1.96489882 1.62392035,1.92826099 C1.58800233,1.89162317 1.53053349,1.88289988 1.48204416,1.90558044 L0.0686699794,2.58250785 C0.00760934129,2.61216704 -0.0175332744,2.68369803 0.0129970446,2.74127175 C0.0956084962,2.90526963 0.203362563,3.05356559 0.334463345,3.17918098 L0.334463345,3.18092564 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.0936, 2.5604)",
    fill: "#F7A016",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33467146,0.631586308 C2.33467146,0.68382806 2.36879358,0.730665493 2.41728291,0.748679891 L3.90967674,1.2566859 C3.97432918,1.27830317 4.04436932,1.24407582 4.06592014,1.17922399 C4.12698077,1.00088145 4.15751109,0.815333161 4.15751109,0.631586308 C4.15751109,0.447839455 4.12698077,0.262291162 4.06592014,0.083948628 C4.04436932,0.0190967975 3.97432918,-0.0151305574 3.90967674,0.0064867194 L2.41728291,0.514492725 C2.36699768,0.530705683 2.33467146,0.579344555 2.33467146,0.631586308 L2.33467146,0.631586308 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.631579145 C0,0.817125217 0.030530319,1.00086987 0.0915909571,1.17921027 C0.113141771,1.24406133 0.183181914,1.27828827 0.247834355,1.25667125 L1.74022819,0.748671326 C1.79051342,0.732458563 1.82283964,0.683820272 1.82283964,0.631579145 C1.82283964,0.579338018 1.79051342,0.532501145 1.74022819,0.514486963 L0.247834355,0.00648703677 C0.183181914,-0.0151299814 0.114937672,0.019096964 0.0915909571,0.0821466003 C0.030530319,0.260487 0,0.446033072 0,0.629777727 L0,0.631579145 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.368, 1.4183)",
    fill: "#F7A016",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.98669238,1.93000565 C1.94897845,1.96664348 1.93999895,2.02072788 1.96334566,2.06783366 L2.6601553,3.44087973 C2.69068561,3.50019811 2.76431756,3.52462332 2.8235823,3.49496413 C2.992397,3.41470985 3.1450486,3.31003036 3.27435348,3.1826703 C3.40365836,3.05531025 3.51320833,2.90875895 3.59581978,2.74476107 C3.6245542,2.68544269 3.59941158,2.6139117 3.54014684,2.58599717 L2.12677266,1.90906975 C2.08007923,1.88638919 2.0226104,1.89511249 1.98489647,1.93175031 L1.98669238,1.93000565 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.334463345,0.32492003 C0.205158464,0.450535427 0.0956084962,0.598831381 0.0129970446,0.76282926 C-0.0175332744,0.822147641 0.00760934129,0.893678631 0.0686699794,0.921593163 L1.48204416,1.59852058 C1.52873759,1.62120114 1.58620643,1.61247784 1.62392035,1.57584002 C1.66163427,1.5392022 1.67061378,1.48511779 1.64726706,1.43975667 L0.950457429,0.066710604 C0.91992711,0.00739222231 0.846295164,-0.0170329937 0.787030427,0.0126261972 C0.618215722,0.0928804783 0.465564127,0.199304634 0.336259246,0.32492003 L0.334463345,0.32492003 Z"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4578AB",
    fillRule: "nonzero",
    x: 3.29097849,
    y: 10.0903175,
    width: 1.90185929,
    height: 1.25615396
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4171A1",
    fillRule: "nonzero",
    x: 4.33439704,
    y: 10.0903175,
    width: 1.29304881,
    height: 1.25615396
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#518FC9",
    fillRule: "nonzero",
    x: 2.02846,
    y: 10.0903175,
    width: 1.29304881,
    height: 1.25615396
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.2,
    points: "5.0689206 9.82164013 2.00152149 9.82164013 1.27418153 4.02239599 5.79805645 4.02239599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30062565,6.4561943 C4.31603678,6.27126052 4.54977213,6.13168786 4.82460381,6.14215581 C5.09686697,6.15436841 5.30491712,6.31313232 5.28693748,6.4980661 L4.98385208,9.82338479 L3.99497173,9.82338479 C3.99497173,9.82338479 4.30319418,6.4561943 4.30319418,6.4561943 L4.30062565,6.4561943 Z",
    id: "Path",
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83286319,4.02239599 L3.03117415,5.99560451 C3.05100524,6.18053829 2.82153114,6.33930219 2.52123169,6.3515148 C2.21809923,6.36372741 1.963128,6.22241009 1.94329691,6.03747631 L1.73931992,4.02239599 L2.83003018,4.02239599 L2.83286319,4.02239599 Z",
    id: "Path",
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.2,
    points: "3.24428506 4.02239599 5.79805645 4.02239599 5.0689206 9.82164013 3.24428506 9.82164013"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBeachChair);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/beach-chair.64a60222cf03ace2e668abadc32314e5.svg";